import { DashboardDetailData, DashboardDetailWidgetData } from '../dashboard-api';
import {
  DashboardDetailWidget,
  dashboardDetailWidgetsFromData,
  updateDashboardDetailWidgetsMobilePosition,
} from './dashboard-detail-widget';

const STORAGE_DEFAULT_GRID_VISIBILITY_KEY = 'mstDefaultWidgetGridVisibility';

function saveDefaultGridVisibility(visible: boolean) {
  localStorage.setItem(STORAGE_DEFAULT_GRID_VISIBILITY_KEY, visible ? 'true' : 'false');
}

function defaultWidgetGridVisibility() {
  return localStorage.getItem(STORAGE_DEFAULT_GRID_VISIBILITY_KEY) === 'true';
}

export interface DashboardDetail extends Omit<DashboardDetailData, 'widgets'> {
  geometry: { width: number };
  showWidgetGrid: boolean;
  widgets: DashboardDetailWidget[];
  widgetToRemove: DashboardDetailWidgetData | undefined;
}

export function initialDashboardDetail(): DashboardDetail {
  return {
    id: '',
    name: '',
    showWidgetGrid: defaultWidgetGridVisibility(),
    widgets: [],
    geometry: { width: 0 },
    widgetToRemove: undefined,
  };
}

export function updateDashboardDetailWidth(model: DashboardDetail, width: number): DashboardDetail {
  return { ...model, geometry: { width } };
}

export function updateDashboardShowLines(model: DashboardDetail, showWidgetGrid: boolean): DashboardDetail {
  saveDefaultGridVisibility(showWidgetGrid);

  return { ...model, showWidgetGrid };
}

export function updateDashboardDetail(model: DashboardDetail, details: DashboardDetailData): DashboardDetail {
  const widgets = updateDashboardDetailWidgetsMobilePosition(dashboardDetailWidgetsFromData(model.widgets, details.widgets));
  return { ...model, ...details, widgets };
}

export function asUpdateDashboardWidget(getModel: () => DashboardDetail, update: (_: DashboardDetail) => void) {
  return (widget: { id: string } & Partial<DashboardDetailWidget>) => update(updateDashboardWidget(getModel(), widget));
}

function updateDashboardWidget(model: DashboardDetail, widget: { id: string } & Partial<DashboardDetailWidget>) {
  const widgets = updateDashboardDetailWidgetsMobilePosition(model.widgets.map((w) => (w.id === widget.id ? { ...w, ...widget } : w)));
  return { ...model, widgets };
}

export function setDashboardWidgetToRemove(model: DashboardDetail, widgetToRemove: DashboardDetailWidgetData | undefined): DashboardDetail {
  return { ...model, widgetToRemove };
}
